import { ExportFileModel, ExportValueType } from '@shared/export/export-interfaces';

const EOL = '\r\n';
const BOM = '\ufeff';
const FIELD_SEPARATOR = ',';

export function createCsvFile<T>({ rows, headers }: ExportFileModel<T>) {
  const headerRow = headers.map(h => h.fieldName || h.fieldKey).join(FIELD_SEPARATOR);
  const dataRows = rows.map(row => headers.map(h => formatData(row[h.fieldKey])).join(FIELD_SEPARATOR));
  const csv = BOM + [headerRow, ...dataRows].join(EOL);

  return new Blob([csv], { type: 'text/csv;charset=utf8;' });
}

function formatData(value: ExportValueType): ExportValueType {
  if (typeof value === 'string') {
    return formatString(value);
  }

  return value;
}

function formatString(data: string) {
  const text = data.replace(/"/g, '""');
  const symbolsToEscape = [FIELD_SEPARATOR, '\n', '\r'];

  if (symbolsToEscape.some(s => data.includes(s))) {
    return `"${text}"`;
  }

  return text;
}
